import React, { useState, useEffect } from "react";
import { getCurrentDate, getFirstDayOfMonth } from "@thequantumhub/iam-package";
import { Grid } from "@material-ui/core";
import { Button, Typography } from "@mui/material";

import { getPatientCareRecords } from "../../../service/endpoint-manager";

import PatientCareForm from "./PatientCareForm";
import PatientCareDataFilters from "./PatientCareDataFilters";
import PatientCareTable from "./PatientCareTable";

const PatientCareDashboard = () => {
  const [isDashboard, setIsDashboard] = useState(true);

  const [patientCareRecords, setPatientCareRecords] = useState([]);
  const [filteredPatientCareRecords, setFilteredPatientCareRecords] = useState(
    []
  );
  const [dataFetched, setDataFetched] = useState(false);

  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("all");
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("all");
  const [recordStatus, setRecordStatus] = useState("Active");
  const [startDate, setStartDate] = useState(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const resetFilters = () => {
    setUnits([]);
    setSelectedUnit("all");
    setStartDate("");
    setEndDate("");
  };

  const loadData = async () => {
    try {
      const response = await getPatientCareRecords({
        deleted: recordStatus === "Deleted",
        from: startDate,
        to: endDate,
      });
      let records = response.data.body;

      setPatientCareRecords(records);
      setDataFetched(true);
    } catch (error) {
      console.error("Error fetching patient care records:", error);
    }
  };

  useEffect(() => {
    setDataFetched(false);
    loadData();
  }, [recordStatus, startDate, endDate]);

  // filter the data when provided filter options change
  useEffect(() => {
    const filterData = () => {
      let filteredRecords = patientCareRecords;

      if (selectedFacility !== "all") {
        filteredRecords = filteredRecords.filter(
          (record) => record.facility === selectedFacility
        );
      }

      if (selectedUnit !== "all") {
        filteredRecords = filteredRecords.filter(
          (record) => record.unit === selectedUnit
        );
      }

      setFilteredPatientCareRecords(filteredRecords);
    };

    filterData();
  }, [patientCareRecords, selectedUnit, selectedFacility]);

  return (
    <div>
      {isDashboard ? (
        <>
          <PatientCareDataFilters
            facilities={facilities}
            setFacilities={setFacilities}
            selectedFacility={selectedFacility}
            setSelectedFacility={setSelectedFacility}
            selectedUnit={selectedUnit}
            setSelectedUnit={setSelectedUnit}
            units={units}
            setUnits={setUnits}
            recordStatus={recordStatus}
            setRecordStatus={setRecordStatus}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            resetFilters={resetFilters}
          />
          <PatientCareTable
            isDashboard={isDashboard}
            setIsDashboard={setIsDashboard}
            patientCareRecords={patientCareRecords}
            setPatientCareRecords={setPatientCareRecords}
            filteredPatientCareRecords={filteredPatientCareRecords}
            setFilteredPatientCareRecords={setFilteredPatientCareRecords}
            dataFetched={dataFetched}
          />

          {/* <div>
            <h2>Current Filters:</h2>
            <p>Facility: {selectedFacility}</p>
            <p>Unit: {selectedUnit}</p>
            <p>Record Status: {recordStatus}</p>
            <p>Start Date: {startDate}</p>
            <p>End Date: {endDate}</p>
          </div>
          <div style={{ marginTop: "100px" }}>
            {filteredPatientCareRecords ? (
              <pre>{JSON.stringify(filteredPatientCareRecords, null, 2)}</pre>
            ) : (
              <p>Fetching Data ...</p>
            )}
          </div> */}
        </>
      ) : (
        <>
          <Grid container alignItems="center">
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsDashboard(true);
                }}
              >
                Return to Dashboard
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography
                variant="h2"
                style={{ textAlign: "center", margin: "20px 0" }}
              >
                Patient Care Form
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}></Grid>
          </Grid>
          <PatientCareForm
            isDashboard={isDashboard}
            setIsDashboard={setIsDashboard}
          />
        </>
      )}
    </div>
  );
};

export default PatientCareDashboard;
